export default "__VITE_ASSET__DKsa6ZZE__"